import styled from 'styled-components';

export const GuaranteeFundSC = styled.main`
  position: relative;
  width: 100%;
  height: 100%;
`;
